import { AssignmentGroupsState } from './state';
import {
  AssignmentGroupsActionsUnion,
  AssignmentGroupsActions
} from './actions';

export const initialState: AssignmentGroupsState = {
  error: undefined,
  loading: false,
  loaded: false,
  saving: false,
  groups: undefined,
  savingError: undefined
};

export function assignmentGroupsReducer(
  state: AssignmentGroupsState = initialState,
  action: AssignmentGroupsActionsUnion
): AssignmentGroupsState {
  switch (action.type) {
    case AssignmentGroupsActions.Load:
      return {
        ...state,
        loaded: false,
        loading: true,
        error: undefined,
        savingError: undefined,
        groups: undefined
      };
    case AssignmentGroupsActions.LoadSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        error: undefined,
        savingError: undefined,
        groups: action.payload.map((g) => ({ ...g, selected: false }))
      };
    case AssignmentGroupsActions.LoadFail:
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action.payload,
        groups: undefined
      };
    case AssignmentGroupsActions.Save:
      return {
        ...state,
        saving: true,
        savingError: undefined
      };
    case AssignmentGroupsActions.SaveSuccess:
      return {
        ...state,
        saving: false,
        groups: [...state.groups, { ...action.payload, selected: false }],
        savingError: undefined
      };
    case AssignmentGroupsActions.SaveFail:
      return {
        ...state,
        saving: false,
        savingError: action.payload
      };
    case AssignmentGroupsActions.Delete:
      return {
        ...state,
        saving: true,
        groups: state.groups.filter((ag) => ag.id !== action.payload),
        savingError: undefined
      };
    case AssignmentGroupsActions.DeleteSuccess:
      return {
        ...state,
        saving: false,
        savingError: undefined
      };
    case AssignmentGroupsActions.DeleteFail:
      return {
        ...state,
        saving: false,
        savingError: action.payload
      };
    case AssignmentGroupsActions.Reset:
      return {
        ...state,
        saving: false,
        groups:
          state.groups && state.groups.map((g) => ({ ...g, selected: false })),
        savingError: undefined
      };
    default:
      return state;
  }
}
